<template>
  <a-row>
    <a-card :title="textbookDetail.title">
      <a slot="extra" @click="copyTOCJSON">复制目录json</a>
      <a-row>
        <a-col span="6">
          <img style="width: 30%"
            :src="textbookDetail.thumbUrl"/>
        </a-col>
        <a-col span="18" style="padding-left: 20px">
          {{textbookDetail.summary}}
        </a-col>
      </a-row>
    </a-card>
    <div style="display:flex;flex-direction: row;justify-content: space-between;margin-top: 20px;margin-bottom: 20px">
      <!-- <a-button type="primary" icon="file-sync"  @click="onClickBookFormat">
        书籍元数据同步
      </a-button> -->
      <!-- <a-button type="primary" icon="file-zip"  @click="onClickBookFormat">
        发布上线
      </a-button> -->
    </div>
    
    <a-table :loading="loading" :columns="columns" rowKey="id" :data-source="toc" :pagination="false" class="components-table-demo-nested">
      <div slot="operationTitle">
        <span>操作</span>
        <CommonPermissions :p="$permissions.TEXTBOOK.UPDATE">
          <a-button style="margin-left: 10px;" size="small" type="primary" @click="addUnit">添加单元</a-button>
        </CommonPermissions>
      </div>
      <template v-for="key in ['_title', 'versionNum', 'folderName']" :slot="key" slot-scope="text, record, index">
        <a-input :key="key" v-if="record.editable" :value="text" @change="e => changeKey(e, record, index, key)"/>
        <template v-else><h6>{{text}}</h6></template>
      </template>
      <div slot="serialName" slot-scope="text, record, index">
        <a-input key="serialName" v-if="record.editable" :value="text" @change="e => changeKey(e, record, index, 'serialName')"/>
        <template v-else>
          <a-tag color="#f50">
            章
          </a-tag>
          <span>{{text}}</span>
        </template>
      </div>
      <div slot="freeTrial" slot-scope="text, record, index">
        <a-select v-if="record.editable" style="width: 100%" :value="text?'1':'0'" @change="e => changeKey({target: {value: e == '1'}}, record, index, 'freeTrial')">
          <a-select-option value="1">
            是
          </a-select-option>
          <a-select-option value="0">
            否
          </a-select-option>
        </a-select>
        <template v-else>
            <a-badge v-if="record.freeTrial" status="success" />
            <a-badge v-else status="processing" />
            {{record.freeTrial?'是':'否'}} 
        </template>
      </div>
      <div slot="separator" slot-scope="text, record, index">
        <a-select v-if="record.editable" style="width: 100%" :value="text?'1':'0'" @change="e => changeKey({target: {value: e == '1'}}, record, index, 'separator')">
          <a-select-option value="1">
            是
          </a-select-option>
          <a-select-option value="0">
            否
          </a-select-option>
        </a-select>
        <template v-else>
            <a-badge v-if="record.separator" status="success" />
            <a-badge v-else status="processing" />
            {{record.separator?'是':'否'}} 
        </template>
      </div>
      <div slot="status" slot-scope="text, record, index">
        <a-select v-if="record.editable" style="width: 100%" :value="text" @change="e => changeKey({target: {value: e}}, record, index, 'status')">
          <a-select-option :value="1">
            上线
          </a-select-option>
          <a-select-option :value="0">
            未上线
          </a-select-option>
        </a-select>
        <template v-else>
            <a-badge v-if="record.status == 1" status="success" />
            <a-badge v-else status="processing" />
            {{record.status == 1?'上线':'未上线'}} 
        </template>
      </div>
      <div slot="operation" slot-scope="text, unit, index">
        <!-- <a v-if="!unit.editable" @click="() => addLesson(unit.id, index)">添加课程</a> -->
        <!-- <a-divider v-if="!unit.editable" type="vertical" /> -->
        <template>
          <a @click="() => editUnit(unit.id, index)">{{unit.editable?'保存':'编辑'}}</a>
          <a-divider v-if="!unit.editable" type="vertical" />
          <a-popconfirm
            title="确认删除吗？"
            ok-text="是"
            cancel-text="否"
            @confirm="() => deleteUnit(unit.id, index)">
            <a v-if="!unit.editable" style="color: red">删除</a>
          </a-popconfirm>
          <a-divider v-if="!unit.editable" type="vertical" />
          <a v-if="!unit.editable" @click="() => dragUnit(unit.id, index, 'MOVE_UP')">上移</a>
          <a-divider v-if="!unit.editable" type="vertical" />
          <a v-if="!unit.editable" @click="() => dragUnit(unit.id, index, 'MOVE_DOWN')">下移</a>
          <a-divider v-if="!unit.editable" type="vertical" />
          <!-- <a-popconfirm
            v-if="unit.folderName!='infor' && !unit.editable"
            title="确认提交审核吗？"
            ok-text="是"
            cancel-text="否"
            @confirm="() => submitUnitToReview(unit.id)">
            <a-button type="primary" icon="audit" size="small">提交审核</a-button> 
          </a-popconfirm> -->
        </template>
        <!-- <template v-if="unit.auditStatus == 3 || unit.auditStatus == -2">
          <a-popconfirm
            title="确认解锁吗？"
            ok-text="是"
            cancel-text="否"
            @confirm="() => reEditUnit(unit.id, index)">
            <a-button v-if="!unit.editable" size="small" type="danger">解锁</a-button>
          </a-popconfirm>
        </template> -->
        <!-- <template v-if="unit.auditStatus == 1">
          <a-tag>审核中</a-tag>
        </template> -->
      </div>
      <!-- <span slot="freeTrial" slot-scope="unit"> 
        <a-badge v-if="unit.freeTrial" status="success" />
        <a-badge v-else status="processing" />
        {{unit.freeTrial?'是':'否'}} 
      </span>
      <span slot="separator" slot-scope="unit">
        <a-badge v-if="unit.separator" status="success" />
        <a-badge v-else status="processing" />
        {{unit.separator?'是':'否'}} 
      </span> -->
      <a-table
        slot="expandedRowRender"
        slot-scope="unit, unitIndex"
        :columns="innerColumns"
        rowKey="id"
        :data-source="unit.lessonList"
        :pagination="false">
        <div slot="operationTitle">
          <span>操作</span>
            <CommonPermissions :p="$permissions.TEXTBOOK.UPDATE">
              <a-button style="margin-left: 10px;" size="small" type="primary" @click="() => addLesson(unit.id, unitIndex)">添加节</a-button>
            </CommonPermissions>
        </div>
        <template v-for="key in ['_title', 'filePath']" :slot="key" slot-scope="text, record, index">
          <a-input :key="key" v-if="record.editable" :value="text" @change="e => changeLessonKey(e, record, unitIndex, index, key)"/>
          <template v-else>{{text}}</template>
        </template>
        <div slot="serialName" slot-scope="text, record, index">
          <a-input key="serialName" v-if="record.editable" :value="text" @change="e => changeLessonKey(e, record, unitIndex, index, 'serialName')"/>
          <template v-else>
            <a-tag color="#2db7f5">
              节
            </a-tag>
            <span>{{text}}</span>
          </template>
        </div>
        <div slot="targetTime" slot-scope="text, record, index">
          <a-input v-if="record.editable" :value="record.targetTime / 1000 / 60" @change="e => changeLessonKey(e, record, unitIndex, index, 'targetTime')"/>
          <span v-else>
            {{record.targetTime / 1000 / 60}}min
          </span>
        </div>
        <div slot="operation" slot-scope="text, record, lessonIndex">
          <template>
            <a @click="() => editLesson(unit.id, unitIndex, record.id, lessonIndex)">{{record.editable?'保存':'编辑'}}</a>
            <a-divider v-if="!record.editable" type="vertical" />
            <a-popconfirm
              title="确认删除吗？"
              ok-text="是"
              cancel-text="否"
              @confirm="() => deleteLesson(record.id, unitIndex, lessonIndex)">
              <a v-if="!record.editable" style="color: red">删除</a>
            </a-popconfirm>
            <a-divider v-if="!unit.editable" type="vertical" />
            <a v-if="!unit.editable" @click="() => dragLesson(record.id, unitIndex, lessonIndex, 'MOVE_UP')">上移</a>
            <a-divider v-if="!unit.editable" type="vertical" />
            <a v-if="!unit.editable" @click="() => dragLesson(record.id, unitIndex, lessonIndex, 'MOVE_DOWN')">下移</a>
            <!-- <a-divider v-if="!unit.editable" type="vertical" />
            <a v-if="!unit.editable" @click="() => openHtmlEditor(unit, record)">制作</a> -->
          </template>
        </div>
        <a-table
          slot="expandedRowRender"
          slot-scope="lesson, lessonIndex"
          :columns="sectionColumns"
          :data-source="lesson.sectionList"
          :pagination="false"
          rowKey="id">
          <div slot="operationTitle">
            <span>序号</span>
            <CommonPermissions :p="$permissions.TEXTBOOK.UPDATE">
              <a-button style="margin-left: 10px;" size="small" type="primary" @click="() => addSection(unitIndex, lessonIndex)">添加练习</a-button>
            </CommonPermissions>
          </div>
          <template slot="filePath" slot-scope="text, record, index">
            <a-input key="filePath" v-if="record.editable && (record.type == 1 || record.type == 2)" :value="text" @change="e => changeSectionKey(e, record, unitIndex, lessonIndex, index, 'filePath')"/>
            <template v-else>{{text}}</template>
          </template>
          <div slot="_title" slot-scope="text, record, index">
            <a-input key="_title" v-if="record.editable" :value="text" @change="e => changeSectionKey(e, record, unitIndex, lessonIndex, index, '_title')"/>
            <template v-else>
              <a-tag color="#87d068">
                题
              </a-tag>
              <span>{{text}}</span>
            </template>
          </div>
          <div slot="drillType" slot-scope="text, record, index">
            <a-select v-if="record.editable" :default-value="record.drillType" @change="e => changeSectionKey({target: {value: e}}, record, unitIndex, lessonIndex, index, 'drillType')">
              <a-select-option v-for="type in drillTypeList" :key="type.id" :value="type.id">
                {{type.name}}
              </a-select-option>
            </a-select>
            <span v-else-if="!record.editable && record.drillType">{{drillTypeMap[record.drillType].name}}</span>
          </div>
          <div slot="seenToc" slot-scope="text, record, index">
            <a-select v-if="record.editable" :default-value="record.seenToc" @change="e => changeSectionKey({target: {value: e}}, record, unitIndex, lessonIndex, index, 'seenToc')">
              <a-select-option :value="true">
                可见
              </a-select-option>
              <a-select-option :value="false">
                不可见
              </a-select-option>
            </a-select>
            <!-- <a-checkbox v-if="record.editable" :default-value="record.seenToc" @change="e => changeSectionKey({target: {value: e.target.checked}}, record, unitIndex, lessonIndex, index, 'seenToc')">
              可见
            </a-checkbox> -->
            <span v-else>{{record.seenToc ? '可见' : '不可见'}}</span>
          </div>
          <div slot="type" slot-scope="text, record, index">
            <a-select style="width: 180px" allowClear v-if="record.editable" :default-value="record.type" @change="e => changeSectionKey({target: {value: e}}, record, unitIndex, lessonIndex, index, 'type')">
              <a-select-option v-for="type in sectionTypeList" :key="type.id" :value="type.id">
                {{type.name}}
              </a-select-option>
            </a-select>
            <span v-else>{{sectionTypeMap[record.type].name}}</span>
          </div>
          <div slot="operation" slot-scope="text, record, sectionIndex">
            <template>
              <a @click="() => editSection(unit.id, unitIndex, lessonIndex, sectionIndex)">{{record.editable?'保存':'编辑'}}</a>
              <a-divider v-if="!record.editable" type="vertical" />
              <a-popconfirm
                title="确认删除吗？"
                ok-text="是"
                cancel-text="否"
                @confirm="() => deleteSection(record.id, unitIndex, lessonIndex, sectionIndex)">
                <a v-if="!record.editable" style="color: red">删除</a>
              </a-popconfirm>
              <a-divider v-if="!unit.editable && (record.type == 0 || record.type == 3 || record.type == 4) && !record.editable" type="vertical" />
              <a @click="() => goEditDrill(record)" v-if="(!unit.editable && record.type == 0) || (record.type == 3 && !record.editable) || (record.type == 4 && !record.editable)">试题</a>
              <a-divider v-if="!unit.editable && (record.type == 5) && !record.editable" type="vertical" />
              <a @click="() => goEditPaper(record)" v-if="!unit.editable && record.type == 5 && !record.editable">试卷</a>
              <a-divider v-if="!unit.editable && !record.editable" type="vertical" />
              <a v-if="!unit.editable && !record.editable" @click="() => dragSection(record.id, unitIndex, lessonIndex, sectionIndex, 'MOVE_UP')">上移</a>
              <a-divider v-if="!unit.editable && !record.editable" type="vertical" />
              <a v-if="!unit.editable && !record.editable" @click="() => dragSection(record.id, unitIndex, lessonIndex, sectionIndex, 'MOVE_DOWN')">下移</a>
              <!-- <a-divider v-if="!unit.editable && !record.editable" type="vertical" />
              <a v-if="!unit.editable && !record.editable" @click="() => copySectionCode(record)">复制代码</a> -->
              <template v-if="record.type == 0 || record.type == 3 || record.type == 4 || record.type == 5">
                <a-divider v-if="!unit.editable && !record.editable" type="vertical" />
                <a v-if="!unit.editable && !record.editable" @click="() => copySectionJSON(record)">复制试题json</a>
              </template>
            </template>
          </div>
        </a-table>
      </a-table>
    </a-table>
    <a-drawer
      placement="right"
      :closable="true"
      width="60%"
      :visible="drillDrawerVisible"
      :bodyStyle="{paddingTop: '0px'}"
      @close="closeDrillList">
      <a-row slot="title">
        <!-- <span>试题/碎片管理</span> -->
        <span>试题管理</span>
      </a-row>
      <a-tabs :activeKey="drillFragmentKey" @change="changeDrillFragmentKey">
        <a-row  slot="tabBarExtraContent">
          <CommonPermissions v-if="drillFragmentKey == 'drill'" :p="$permissions.TEXTBOOK.UPDATE">
            <a-button type="primary" @click="goAIImportDrill">AI导题</a-button>
          </CommonPermissions>
          <a-divider type="vertical" />
          <CommonPermissions v-if="drillFragmentKey == 'drill'" :p="$permissions.TEXTBOOK.UPDATE">
            <a-button type="primary" @click="addDrill">添加试题</a-button>
          </CommonPermissions>
          <CommonPermissions v-if="drillFragmentKey == 'fragment'" :p="$permissions.TEXTBOOK.UPDATE">
            <a-button type="primary" @click="openAddFragmentModal">添加碎片</a-button>
          </CommonPermissions>
        </a-row>
        <a-tab-pane key="drill" tab="试题">
          <a-table
            size="middle"
            :loading="loading"
            rowKey="id"
            @change="drillPageChange"
            :pagination="{current: currentDrillPageNum, total: drillCount, pageSize: 20}"
            :columns="drillColumns" 
            :data-source="drillList">
            <template slot="createAccount" slot-scope="record">
              <div v-if="record.company">
                <a-avatar shape="square" :size="20" icon="user" :src="record.company.logoUrl"/> 
                <span style="color: #4a4a4a;padding-right: 10px;">{{record.company.abbr}}</span>
              </div>
              <div v-if="record.createAccount" style="display: flex;align-items: center;">
                <a-avatar :size="20" icon="user" :src="record.createAccount.avatarUrl"/> {{record.createAccount.name}}
              </div>
              <span v-else>暂无上传者信息</span>
            </template>
            <template slot="cusTitle" slot-scope="record">
              <div style="display: flex">
                <div>
                  <div>{{record.text}}</div>
                </div>
              </div>
            </template>
            <template slot="subType" slot-scope="record">
              <span v-if="record.subType == 101">单项选择题</span>
              <span v-if="record.subType == 102">多项选择题</span>
              <span v-if="record.subType == 103">判断题</span>
              <span v-if="record.subType == 201">看文字填空题</span>
              <span v-if="record.subType == 202">听录音填空题</span>
              <span v-if="record.subType == 301">简答题</span>
              <span v-if="record.subType == 302">翻译题</span>
              <span v-if="record.subType == 401">对话题</span>
              <span v-if="record.subType == 501">看文字朗读</span>
              <span v-if="record.subType == 502">听录音复诵</span>
              <span v-if="record.subType == 503">口译</span>
              <span v-if="record.subType == 601">阅读理解题</span>
              <span v-if="record.subType == 602">听力理解题</span>
              <span v-if="record.subType == 701">排序题</span>
              <span v-if="record.subType == 801">听力理解排序题</span>
              <a-tag color="red" v-if="record.required" style="margin-left: 10px">必做</a-tag>
            </template>
            <template slot="active" slot-scope="record">
              <!-- <a-button type="link" size="small" @click="seeDetail(record)">预览</a-button> -->
              <a-button type="link" size="small" @click="editDrill(record)">编辑</a-button>
                <a-popconfirm
                    title="确定删除该试题吗?"
                    ok-text="是"
                    cancel-text="否"
                    @confirm="() => deleteDrill(record)">
                  <a-button type="link" size="small" class="right15">删除</a-button>
                </a-popconfirm>
            </template>
          </a-table>
        </a-tab-pane>
        <!-- <a-tab-pane key="fragment" tab="碎片">
          <a-table
            size="middle"
            :loading="loading"
            rowKey="id"
            @change="fragmentPageChange"
            :pagination="{current: currentFragmentPageNum, total: fragmentCount}"
            :columns="fragmentColumns" 
            :data-source="fragmentList">
            <template slot="createAccount" slot-scope="record">
              <div v-if="record.company">
                <a-avatar shape="square" :size="20" icon="user" :src="record.company.logoUrl"/> 
                <span style="color: #4a4a4a;padding-right: 10px;">{{record.company.abbr}}</span>
              </div>
              <div v-if="record.createAccount" style="display: flex;align-items: center;">
                <a-avatar :size="20" icon="user" :src="record.createAccount.avatarUrl"/> {{record.createAccount.name}}
              </div>
              <span v-else>暂无上传者信息</span>
            </template>
            <template slot="cusTitle" slot-scope="record">
              <div style="display: flex">
                <div>
                  <div>{{record.title}}</div>
                </div>
              </div>
            </template>
            <template slot="active" slot-scope="record">
              <a-button type="link" size="small" @click="removeFragment(record)">删除</a-button>
            </template>
          </a-table>
        </a-tab-pane> -->
      </a-tabs>
    </a-drawer>
    <a-drawer
      placement="right"
      :closable="true"
      width="800"
      :visible="paperDrawerVisible"
      :bodyStyle="{paddingTop: '0px'}"
      @close="closePaperList">
      <a-row slot="title">
        <span v-if="sectionExam.id">试卷名称: {{ sectionExam.paper.name }}</span>
        <span v-else>试卷设置</span>
      </a-row>
      <a-spin :spinning="loading">
        <a-form-model-item v-if="!sectionExam.id" label="课程标准" name="summary">
          <a-select style="width: 100%" v-model="sectionExam.textbookCourseStandId" @change="changePaperCourseStand">
            <a-select-option v-for="courseStand in textbookCourseStandList" :value="courseStand.id" :key="courseStand.id">
              {{courseStand.name}}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item v-if="!sectionExam.id" label="试卷" name="code">
          <a-select style="width: 100%" v-model="sectionExam.paperId">
            <a-select-option v-for="paper in paperList" :value="paper.id" :key="paper.id">
              {{paper.name}}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="考试说明" name="code">
          <a-input v-model="sectionExam.summary" placeholder="请填写考试说明"/>
        </a-form-model-item>
        <a-form-model-item label="考试次数限制" name="code">
          <a-input v-model="sectionExam.triesLimit" placeholder="请填写考试次数限制, 不填为不限制"/>
        </a-form-model-item>
        <a-form-model-item label="考试时间限制(单位秒)" name="code">
          <a-input v-model="sectionExam.timeLimit" placeholder="请填写考试时间限制,单位秒 不填为不限制"/>
        </a-form-model-item>
        <a-button type="primary" block @click="saveSectionExam">
          保存
        </a-button>
      </a-spin>
    </a-drawer>
    <a-modal v-model="visible" title="选择试题类型" @ok="selectDrillType" cancelText="取消" okText="确定">
      <!-- <a-radio-group v-model="currentSubDrillType">
        <a-radio v-for="drillType in subDrillTypeList" :key="drillType.id" style="display: block" :value="drillType.id">
          {{drillType.name}}
        </a-radio>
      </a-radio-group> -->
      <a-cascader :options="subDrillTypeList" placeholder="请选择题型" :fieldNames="{ label: 'name', value: 'id', children: 'subType' }" @change="changeCurrentSubDrillType" />
    </a-modal>
    <a-modal v-model="addFragmentVisible" title="添加碎片" @ok="addFragment" cancelText="取消" okText="确定" :confirmLoading="loading">
      <!-- <a-radio-group v-model="currentSubDrillType">
        <a-radio v-for="drillType in subDrillTypeList" :key="drillType.id" style="display: block" :value="drillType.id">
          {{drillType.name}}
        </a-radio>
      </a-radio-group> -->
      <a-input v-model="currentFragmentId" placeholder="请输入碎片id"/>
    </a-modal>
    <ChoiceQuestionEdit @success="success" :currentDrillId="currentDrillId" :visibleTimes="showChoiceQuestionTimes" :subType="currentSubDrillType" :selectedKeys="selectedKeys" :sectionId="currentSectionId"/>
    <GapFillingEdit @success="success" :currentDrillId="currentDrillId" :visibleTimes="showGapFillingTimes" :subType="currentSubDrillType" :selectedKeys="selectedKeys" :sectionId="currentSectionId"/>
    <EssayQuestionEdit @success="success" :currentDrillId="currentDrillId" :visibleTimes="showEssayQuestionTimes" :subType="currentSubDrillType" :selectedKeys="selectedKeys" :sectionId="currentSectionId"/>
    <DialogueEdit @success="success" :currentDrillId="currentDrillId" :visibleTimes="showDialogueTimes" :subType="currentSubDrillType" :selectedKeys="selectedKeys" :sectionId="currentSectionId"/>
    <ReadbackEdit @success="success" :currentDrillId="currentDrillId" :visibleTimes="showReadbackTimes" :subType="currentSubDrillType" :selectedKeys="selectedKeys" :sectionId="currentSectionId"/>
    <PassageChoiceEdit @success="success" :currentDrillId="currentDrillId" :visibleTimes="showPassageChoiceTimes" :subType="currentSubDrillType" :selectedKeys="selectedKeys" :sectionId="currentSectionId"/>
    <SequencingDrillEdit @success="success" :currentDrillId="currentDrillId" :visibleTimes="showSequencingDrillTimes" :subType="currentSubDrillType" :selectedKeys="selectedKeys" :sectionId="currentSectionId"/>
    <PassageSequencingDrillEdit @success="success" :currentDrillId="currentDrillId" :visibleTimes="showPassageSequencingDrillTimes" :subType="currentSubDrillType" :selectedKeys="selectedKeys" :sectionId="currentSectionId"/>
  </a-row>
</template>
<script>
import copy from 'copy-to-clipboard';
import fetch from 'isomorphic-fetch';
import JSONbig from 'json-bigint';
import {copyObjsKeyVal} from '../../../utils/index'
import ChoiceQuestionEdit from './drill/ChoiceQuestionEdit'
import GapFillingEdit from './drill/GapFillingEdit'
import EssayQuestionEdit from './drill/EssayQuestionEdit'
import DialogueEdit from './drill/DialogueEdit'
import ReadbackEdit from './drill/ReadbackEdit'
import PassageChoiceEdit from './drill/PassageChoiceEdit'
import SequencingDrillEdit from './drill/SequencingDrillEdit'
import PassageSequencingDrillEdit from './drill/PassageSequencingDrillEdit'
import CommonPermissions from '@/components/CommonPermissions'
import {DRILL_TYPE_LIST, DRILL_TYPE_MAP, SECTION_TYPE_MAP, SECTION_TYPE_LIST, SUB_DRILL_TYPE_LIST} from '@/utils/drillType/index.js'
import DrillApi from '../../../api/src/drill/api/DrillApi.js'
const drillApi = new DrillApi()
import FragmentApi from '../../../api/src/course_standard/api/FragmentApi.js'
const fragmentApi = new FragmentApi()
import ChoiceQuestionDrillApi from '../../../api/src/drill/api/ChoiceQuestionDrillApi.js'
import GapFillingDrillApi from '../../../api/src/drill/api/GapFillingDrillApi.js'
import EssayQuestionDrillApi from '../../../api/src/drill/api/EssayQuestionDrillApi.js'
import ReadbackDrillApi from '../../../api/src/drill/api/ReadbackDrillApi.js'
import DialogueDrillApi from '../../../api/src/drill/api/DialogueDrillApi.js'
import PassageSequencingDrillApi from '../../../api/src/drill/api/PassageSequencingDrillApi.js'
import CourseStandardApi from '../../../api/src/course_standard/api/CourseStandardApi.js'
import TextBookApi from '../../../api/src/textbook/api/TextBookApi.js'

import PaperApi from '../../../api/src/course_standard/api/PaperApi.js'
import PassageChoiceDrillApi from '../../../api/src/drill/api/PassageChoiceDrillApi.js'
import SequencingDrillApi from '../../../api/src/drill/api/SequencingDrillApi.js'
const passageSequencingDrillApi = new PassageSequencingDrillApi()
const choiceQuestionDrillApi = new ChoiceQuestionDrillApi()
const gapFillingDrillApi = new GapFillingDrillApi()
const essayQuestionDrillApi = new EssayQuestionDrillApi()
const readbackDrillApi = new ReadbackDrillApi()
const dialogueDrillApi = new DialogueDrillApi()
const courseStandardApi = new CourseStandardApi()
const textBookApi = new TextBookApi()
const paperApi = new PaperApi()
const passageChoiceDrillApi = new PassageChoiceDrillApi()
const sequencingDrillApi = new SequencingDrillApi()
const JSONbigString = JSONbig({ storeAsString: true })

const columns = [
  { title: '序号', dataIndex: 'serialName', key: 'serialName', scopedSlots: { customRender: 'serialName' } },
  { title: '标题', dataIndex: '_title', key: 'title', scopedSlots: { customRender: '_title' } },
  { title: '是否试看', dataIndex: 'freeTrial', key: 'freeTrial', scopedSlots: { customRender: 'freeTrial' } },
  { title: '版本号', dataIndex: 'versionNum', key: 'versionNum', scopedSlots: { customRender: 'versionNum' } },
  { title: '文件夹名称', dataIndex: 'folderName', key: 'folderName', scopedSlots: { customRender: 'folderName' } },
  { title: '是否虚拟章节', dataIndex: 'separator', key: 'separator', scopedSlots: { customRender: 'separator' } },
  // { title: '是否上线', dataIndex: 'status', key: 'status', scopedSlots: { customRender: 'status' } },
  { key: 'operation', scopedSlots: { customRender: 'operation', title: 'operationTitle' } },
];

const innerColumns = [
  { title: '序号', dataIndex: 'serialName', key: 'serialName', scopedSlots: { customRender: 'serialName' } },
  { title: '标题', dataIndex: '_title', key: 'title',  scopedSlots: { customRender: '_title' } },
  { title: '文件路径', dataIndex: 'filePath', key: 'filePath', scopedSlots: { customRender: 'filePath' } },
  { title: '字数', dataIndex: 'wordCount', key: 'wordCount' },
  { title: '目标学习时间', key: 'targetTime', scopedSlots: { customRender: 'targetTime' } },
  { key: 'operation', scopedSlots: { customRender: 'operation', title: 'operationTitle' }},
];

const sectionColumns = [
  { title: '标题', dataIndex: '_title', key: 'title',  scopedSlots: { customRender: '_title' } },
  { title: 'id', dataIndex: 'id', key: 'id' },
  { title: '文件路径', dataIndex: 'filePath', key: 'filePath', scopedSlots: { customRender: 'filePath' } },
  // { title: '题型', dataIndex: 'drillType', key: 'drillType', scopedSlots: { customRender: 'drillType' } },
  { title: '目录中显示', dataIndex: 'seenToc', key: 'seenToc', scopedSlots: { customRender: 'seenToc' } },
  { title: '类型', dataIndex: 'type', key: 'type', scopedSlots: { customRender: 'type' }},
  { key: 'operation', scopedSlots: { customRender: 'operation', title: 'operationTitle' }},
];

export default {
  name: "TextbookEdit",
  components: {ChoiceQuestionEdit, GapFillingEdit, EssayQuestionEdit, DialogueEdit, ReadbackEdit, PassageChoiceEdit, SequencingDrillEdit, PassageSequencingDrillEdit, CommonPermissions},
  data() {
    return {
      paperDrawerVisible: false,
      drillFragmentKey: 'drill',
      addFragmentVisible: false,
      currentFragmentId: undefined,
      loading: false,
      columns,
      innerColumns,
      sectionColumns,
      textbookDetail: {},
      toc: [],
      subDrillTypeList: [],
      drillTypeList: DRILL_TYPE_LIST,
      drillTypeMap: DRILL_TYPE_MAP,
      drillDrawerVisible: false,
      currentDrillPageNum: 1,
      currentFragmentPageNum: 1,
      drillList: [],
      fragmentList: [],
      drillCount: 0,
      fragmentCount: 0,
      sectionTypeList: SECTION_TYPE_LIST,
      sectionTypeMap: SECTION_TYPE_MAP,
      drillColumns: [
        {
          title: '题型',
          key: 'subType',
          scopedSlots: {customRender: 'subType'}
        },{
          title: '标题',
          key: 'title',
          scopedSlots: {customRender: 'cusTitle'}
        }, {
          title: '上传者',
          key: 'createAccount ',
          scopedSlots: {customRender: 'createAccount'}
        }, {
          title: '操作',
          width: 240,
          type: 'active',
          scopedSlots: {customRender: 'active'}
        }
      ],
      fragmentColumns: [{
          title: '标题',
          key: 'title',
          scopedSlots: {customRender: 'cusTitle'}
        }, {
          title: '上传者',
          key: 'createAccount ',
          scopedSlots: {customRender: 'createAccount'}
        }, {
          title: '操作',
          width: 240,
          type: 'active',
          scopedSlots: {customRender: 'active'}
        }
      ],
      currentSectionId: undefined,
      currentDrillId: undefined,
      currentSubDrillType: undefined,
      showChoiceQuestionTimes: 0,
      showGapFillingTimes: 0,
      showEssayQuestionTimes: 0,
      showDialogueTimes: 0,
      showReadbackTimes: 0,
      showPassageChoiceTimes: 0,
      showSequencingDrillTimes: 0,
      showPassageSequencingDrillTimes: 0,
      selectedKeys: [undefined],
      visible: false,

      textbookCourseStandList: [],
      paperList: [],
      currentSection: {},
      sectionExam: {
        id: undefined,
        textbookCourseStandId: undefined,
        paperId: undefined,
        name: undefined,
        summary: '',
        triesLimit: 0,
        timeLimit: 0
      }
    }
  },
  async created() {
    const {id} = this.$route.params;
    this.loading = true
    let toc = await textBookApi.getToc(id, 1)
    console.log(toc)
    toc.forEach((unit, unitIndex) => {
      unit._title = unit.title
      unit.sortKey = unitIndex
      if(unit.lessonList){
        unit.lessonList.forEach((lesson, lessonIndex) => {
          lesson._title = lesson.title
          lesson.sortKey = lessonIndex
          if(lesson.sectionList){
            lesson.sectionList.forEach((section, sectionIndex) => {
              section._title = section.title
              section.sortKey = sectionIndex
            });
          } 
        });
      }
    });
    let textbookDetail = await textBookApi.findTextBookById(id)
    this.toc = toc
    this.textbookDetail = textbookDetail
    this.loading = false
  },
  mounted() {
  },
  methods: {
    goAIImportDrill() {
      let unitId = undefined
      let lessonId = undefined
      let find = false
      for(let ui = 0; ui < this.toc.length; ui++) {
        for(let li = 0; li < this.toc[ui].lessonList.length; li++) {
          for(let si = 0; si < this.toc[ui].lessonList[li].sectionList.length; si++) {
            if(this.toc[ui].lessonList[li].sectionList[si].id == this.currentSectionId) {
              find = true
              unitId = this.toc[ui].id
              lessonId = this.toc[ui].lessonList[li].id
              break
            }
          }
          if(find) {
            break
          }
        }
        if(find) {
          break
        }
      }
      if(find) {
        const {href} = this.$router.resolve({name: 'TextbookAIImport', params: {textbookId: this.textbookDetail.id, unitId: unitId.toString(), lessonId: lessonId.toString(), sectionId: this.currentSectionId}})
        window.open(href)
      }
    },
    async copySectionJSON(section) {
      console.log(section)
      this.loading = true
      let resp = await fetch(`/api/drill/section_drill/?sectionId=${section.id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include'
      });
      let jsonStr = await resp.text();
      let sectionJson = JSONbigString.parse(jsonStr)
      sectionJson.sectionId = section.id
      sectionJson.type = section.type
      copy(JSONbigString.stringify(sectionJson), {
        format: 'text/plain'
      })
      this.loading = false
      this.$message.success('复制成功')
    },
    copyTOCJSON() {
      console.log(this.toc)
      console.log(this.textbookDetail)
      let output = {
        "textbookId": `${this.textbookDetail.id}`,
        "name": this.textbookDetail.title,
        "title": this.textbookDetail.title,
        "unitList": []
      }

      for(let ui = 0; ui < this.toc.length; ui++) {
        let name = `${this.toc[ui].serialName} ${this.toc[ui].title}`
        let unit = {
          "id": this.toc[ui].id,
          "name": name.trim(),
          "serialName": this.toc[ui].serialName,
          "title": this.toc[ui].title,
          "freeTrial": this.toc[ui].freeTrial,
          "separator": this.toc[ui].separator,
          "path": this.toc[ui].folderName,
          "lessonList": []
        }
        if(this.toc[ui].lessonList && this.toc[ui].lessonList.length > 0) {
          unit.lessonList = []
          for(let li = 0; li < this.toc[ui].lessonList.length; li++) {
            let name = `${this.toc[ui].lessonList[li].serialName} ${this.toc[ui].lessonList[li].title}`
            unit.lessonList.push({
                "id": this.toc[ui].lessonList[li].id,
                "name": name.trim(),
                "serialName": this.toc[ui].lessonList[li].serialName,
                "title": this.toc[ui].lessonList[li].title,
                "freeTrial": this.toc[ui].lessonList[li].freeTrial,
                "separator": this.toc[ui].lessonList[li].separator,
                "path": this.toc[ui].lessonList[li].filePath
            })
          }
        }
        output.unitList.push(unit)
      }
      console.log(output)
      copy(JSONbig.stringify(output), {
        format: 'text/plain'
      })
      this.$message.success('复制成功')
    },
    async reEditUnit(unitId) {
      this.loading = true
      await textBookApi.reEditUnit(unitId)
      this.loading = false
      window.location.reload()
    },
    changeDrillFragmentKey(key) {
      this.drillFragmentKey = key
    },
    async addUnit() {
      let toc = [...this.toc]
      let unit = Object.assign({}, {
        status: 0,
        versionNum: 1,
        serialName: '',
        _title: '',
        freeTrial: false,
        folderName: '',
        md5: '',
        separator: false,
        auditStatus: 0,
        lessonList: []
      })
      unit.serialName = `第${toc.length + 1}章`
      unit.title = ''
      unit.sortKey = toc.length
      unit.textbookId = this.textbookDetail.id
      this.loading = true
      let resp = await textBookApi.addUnit(unit)
      // let resp = await this.$store.dispatch('textbook/addUnit', unit)
      unit.id = resp.id
      toc.push(unit)
      this.toc = toc
      this.loading = false
    },
    async editUnit(unitId, index) {
      console.log(unitId, index)
      let toc = [...this.toc]
      let unit = toc[index]
      if(unit.editable){
        unit.textbookId = this.textbookDetail.id
        this.loading = true
        try{
          await textBookApi.updateUnit(unit.id, unit)
        }catch(e) {
          console.log('error')
          console.log(e)
        }
      }
      toc[index].editable = !toc[index].editable
      this.toc = toc
      this.loading = false
    },
    async editLesson(unitId, unitIndex, lessonId, lessonIndex) {
      console.log(unitId, unitIndex, lessonId, lessonIndex)
      let toc = [...this.toc]
      let unit = toc[unitIndex]
      let lesson = unit.lessonList[lessonIndex]
      if(lesson.editable){
        lesson.unitId = unit.id
        this.loading = true
        await textBookApi.updateLesson(lesson.id, lesson)
      }
      toc[unitIndex].lessonList[lessonIndex].editable = !toc[unitIndex].lessonList[lessonIndex].editable
      this.toc = toc
      this.loading = false
    },
    changeKey(e, record, index, key) {
      let toc = [...this.toc]
      toc[index][key] = e.target.value
      if(key == '_title'){
        toc[index].title = e.target.value
      }
      this.toc = toc
    },
    changeLessonKey(e, record, unitIndex, index, key) {
      let toc = [...this.toc]
      if(key == 'targetTime'){
        toc[unitIndex].lessonList[index].targetTime = e.target.value * 60 * 1000
      }else{
        toc[unitIndex].lessonList[index][key] = e.target.value
      }
      if(key == '_title'){
        toc[unitIndex].lessonList[index].title = e.target.value
      }
      this.toc = toc
    },
    async addLesson(unitId, index) {
      let toc = [...this.toc]
      console.log(toc)
      let unit = this.toc[index]
      let lesson = Object.assign({}, {
        serialName: '',
        _title: '',
        filePath: '',
        html: '',
        wordCount: 0,
        targetTime: 0,
        sectionList: []
      })
      lesson.unitId = unit.id,
      lesson.serialName = `第${unit.lessonList.length + 1}节`
      lesson.title = ''
      lesson.sortKey = unit.lessonList.length
      this.loading = true
      let resp = await textBookApi.addLesson(lesson)
      lesson.id = resp.id
      toc[index].lessonList.push(lesson)
      this.toc = toc
      this.loading = false
    },
    async addSection(unitIndex, lessonIndex) {
      let toc = [...this.toc]
      let unit = toc[unitIndex]
      let lesson = toc[unitIndex].lessonList[lessonIndex]
      let section = {
        _title: '',
        drillType: 1,
        type: 1,
        filePath: '',
        seenToc: false
      }
      section.lessonId = lesson.id
      section.unitId = unit.id
      section.textbookId = this.textbookDetail.id
      section.title = `${lesson.sectionList.length + 1}`
      section._title = `${lesson.sectionList.length + 1}`
      // this.loading = true1
      // let resp = await this.$store.dispatch('textbook/addSection', section)
      // section.id = resp.id
      // section.id = '0'
      section.editable = true
      toc[unitIndex].lessonList[lessonIndex].sectionList.push(section)
      this.toc = toc
      // this.loading = false
    },
    async editSection(unitId, unitIndex, lessonIndex, sectionIndex) {
      console.log(unitId, unitIndex, lessonIndex, sectionIndex)
      let toc = [...this.toc]
      let unit = toc[unitIndex]
      let lesson = unit.lessonList[lessonIndex]
      console.log(lesson)
      let section = lesson.sectionList[sectionIndex]
      if(section.editable){
        this.loading = true
        if(!section.id){
          let resp = await textBookApi.addSection(section)
          section.id = resp.id
          toc[unitIndex].lessonList[lessonIndex].sectionList[sectionIndex] = section
        }else{
          await textBookApi.updateSection(section.id, section)
        }
      }
      toc[unitIndex].lessonList[lessonIndex].sectionList[sectionIndex].editable = !toc[unitIndex].lessonList[lessonIndex].sectionList[sectionIndex].editable
      this.toc = toc
      this.loading = false
    },
    changeSectionKey(e, record, unitIndex, lessonIndex, index, key) {
      console.log(e, record, unitIndex, lessonIndex, index, key)
      let toc = [...this.toc]
      if(key == 'targetTime'){
        toc[unitIndex].lessonList[lessonIndex].sectionList[index].targetTime = e.target.value * 60 * 1000
      }else{
        toc[unitIndex].lessonList[lessonIndex].sectionList[index][key] = e.target.value
      }
      if(key == '_title'){
        toc[unitIndex].lessonList[lessonIndex].sectionList[index].title = e.target.value
      }
      this.toc = toc
    },
    async deleteUnit(unitId, index) {
      let toc = [...this.toc]
      toc.splice(index, 1)
      this.loading = true
      await textBookApi.deleteUnit(unitId)
      this.toc = toc
      this.loading = false
    },
    async deleteLesson(lessonId, unitIndex, lessonIndex) {
      let toc = [...this.toc]
      toc[unitIndex].lessonList.splice(lessonIndex, 1)
      this.loading = true
      await textBookApi.deleteLesson(lessonId)
      this.toc = toc
      this.loading = false
    },
    async deleteSection(sectionId, unitIndex, lessonIndex, sectionIndex) {
      let toc = [...this.toc]
      toc[unitIndex].lessonList[lessonIndex].sectionList.splice(sectionIndex, 1)
      this.loading = true
      await textBookApi.deleteSection(sectionId)
      this.toc = toc
      this.loading = false
    },
    async dragUnit(unitId, index, direction) {
      let sortKey = index
      if(direction == 'MOVE_UP' && index == 0){
        this.$message.warning('已经是第一单元')
        return
      }
      if(direction == 'MOVE_DOWN' && index == this.toc.length - 1){
        this.$message.warning('已经是最后一单元')
        return
      }
      let toc = [...this.toc]
      let unit = toc[index]
      if(direction == 'MOVE_UP'){
        sortKey = sortKey - 1
      }
      if(direction == 'MOVE_DOWN'){
        sortKey = sortKey + 1
      }
      toc.splice(index, 1)
      toc.splice(sortKey, 0, unit)
      this.loading = true
      await textBookApi.dragUnit({id: unit.id, pid: this.textbookDetail.id, sortKey: sortKey})
      this.toc = toc
      this.loading = false
    },
    async dragLesson(lessonId, unitIndex, lessonIndex, direction) {
      let sortKey = lessonIndex
      let toc = [...this.toc]
      let unit = toc[unitIndex]
      let lesson = unit.lessonList[lessonIndex]
      if(direction == 'MOVE_UP' && lessonIndex == 0){
        this.$message.warning('已经是第一节')
        return
      }
      if(direction == 'MOVE_DOWN' && lessonIndex == unit.lessonList.length - 1){
        this.$message.warning('已经是最后一节')
        return
      }
      if(direction == 'MOVE_UP'){
        sortKey = sortKey - 1
      }
      if(direction == 'MOVE_DOWN'){
        sortKey = sortKey + 1
      }
      toc[unitIndex].lessonList.splice(lessonIndex, 1)
      toc[unitIndex].lessonList.splice(sortKey, 0, lesson)
      this.loading = true
      await textBookApi.dragLesson({id: lessonId, pid: unit.id, sortKey: sortKey})
      this.toc = toc
      this.loading = false
    },
    async dragSection(sectionId, unitIndex, lessonIndex, sectionIndex, direction) {
      let sortKey = sectionIndex
      let toc = [...this.toc]
      let unit = toc[unitIndex]
      let lesson = unit.lessonList[lessonIndex]
      let section = lesson.sectionList[sectionIndex]
      if(direction == 'MOVE_UP' && sectionIndex == 0){
        this.$message.warning('已经是第一题')
        return
      }
      if(direction == 'MOVE_DOWN' && sectionIndex == lesson.sectionList.length - 1){
        this.$message.warning('已经是最后一题')
        return
      }
      if(direction == 'MOVE_UP'){
        sortKey = sortKey - 1
      }
      if(direction == 'MOVE_DOWN'){
        sortKey = sortKey + 1
      }
      toc[unitIndex].lessonList[lessonIndex].sectionList.splice(sectionIndex, 1)
      toc[unitIndex].lessonList[lessonIndex].sectionList.splice(sortKey, 0, section)
      this.loading = true
      await textBookApi.dragSection({id: sectionId, pid: lesson.id, sortKey: sortKey})
      this.toc = toc
      this.loading = false
    },
    goEditDrill(section) {
      console.debug(section)
      if(section.type == 0){
        this.subDrillTypeList = DRILL_TYPE_LIST
      }else if(section.type == 3){
        this.subDrillTypeList = DRILL_TYPE_LIST.filter(item => {return item.key == 'DIALOGUE_DRILL'})
      }else if(section.type == 4){
        this.subDrillTypeList = DRILL_TYPE_LIST.filter(item => {return item.key == 'DIALOGUE_DRILL'})
      }
      // this.subDrillTypeList = DRILL_TYPE_MAP[section.drillType].subType
      this.currentSectionId = section.id.toString()
      this.drillDrawerVisible = true
      this.getDrillData(1, section.id)
      this.getFragmentData(1, section.id)
    },
    closeDrillList() {
      this.drillDrawerVisible = false
    },
    async goEditPaper(section) {
      this.loading = true
      console.log(section)
      this.paperDrawerVisible = true
      this.currentSectionId = section.id
      let sectionExam = await textBookApi.getSectionExam(section.id)
      if(sectionExam){
        this.sectionExam.id = sectionExam.id
        this.sectionExam.summary = sectionExam.summary
        this.sectionExam.triesLimit = sectionExam.triesLimit
        this.sectionExam.timeLimit = sectionExam.timeLimit
        this.sectionExam.paper = sectionExam.paper
        this.loading = false
        return
      }
      let resp = await courseStandardApi.getCourseStandardListByTextbookId({textBookId: this.$route.params.id})
      console.log(resp)
      this.textbookCourseStandList = resp
      this.loading = false
    },
    async changePaperCourseStand(courseStandId) {
      this.loading = true
      console.log(courseStandId)
      let resp = await paperApi.findPagingPaper(courseStandId, 1, {})
      console.log(resp)
      this.paperList = resp.list
      this.loading = false
    },
    async saveSectionExam() {
      console.log(this.sectionExam)
      console.log(this.currentSectionId)
      try{
        this.loading = true
        if(this.sectionExam.id){
          await textBookApi.updateSectionExam(this.currentSectionId, this.sectionExam)
        }else{
          await textBookApi.createSectionExam(this.currentSectionId, this.sectionExam)          
        }
        this.loading = false
      }catch(e) {
        this.$message.error(e.msg)
      }
      this.paperDrawerVisible = false
    },
    closePaperList() {
      this.paperDrawerVisible = false
      this.currentSectionId = undefined
      this.sectionExam = {
        id: undefined,
        textbookCourseStandId: undefined,
        paperId: undefined,
        name: undefined,
        summary: undefined,
        triesLimit: undefined,
        timeLimit: undefined
      }
      this.textbookCourseStandList = []
      this.paperList = []
    },
    async getDrillData(pageNum, sectionId) {
      let reqData = {
        pageNum: pageNum || this.currentDrillPageNum,
        sectionId: sectionId
      };
      this.loading = true;
      let resp = await drillApi.findPage(reqData.pageNum, reqData)
      this.currentDrillPageNum = reqData.pageNum
      this.drillList = resp.list
      this.drillCount = resp.total
      this.loading = false
      console.debug(resp);
    },
    async getFragmentData(pageNum, sectionId) {
      let reqData = {
        pageNum: pageNum || this.currentDrillPageNum,
        sectionId: sectionId
      };
      this.loading = true;
      let resp = await fragmentApi.findPagingSectionLinked(sectionId, pageNum)
      this.currentFragmentPageNum = reqData.pageNum
      this.fragmentList = resp.list
      this.fragmentCount = resp.total
      this.loading = false
      console.debug(resp);
    },
    async removeFragment(fragment) {
      console.log(fragment)
      try{
        this.loading = true
        await fragmentApi.removeSectionLink(this.currentSectionId, fragment.id)
        await this.getFragmentData(1, this.currentSectionId)
      }catch(e) {
        this.$message.error(e)
      }finally{
        this.loading = false
      }
    },
    drillPageChange(e) {
      this.getDrillData(e.current, this.currentSectionId);
    },
    fragmentPageChange(e) {
      this.getFragmentData(e.current, this.currentSectionId);
    },
    editDrill(drill) {
      console.debug(drill)
      this.currentDrillId = drill.id.toString()
      this.currentSubDrillType = drill.subType
      if(drill.subType < 200){
        this.showChoiceQuestionTimes++
      }else if(drill.subType < 300){
        this.showGapFillingTimes++
      }else if(drill.subType < 400){
        this.showEssayQuestionTimes++
      }else if(drill.subType < 500){
        this.showDialogueTimes++
      }else if(drill.subType < 600){
        this.showReadbackTimes++
      }else if(drill.subType < 700){
        this.showPassageChoiceTimes++
      }else if(drill.subType < 800){
        this.showSequencingDrillTimes++
      }else if(drill.subType < 900){
        this.showPassageSequencingDrillTimes++
      }
    },
    success({isNew, id, addDrill}) {
      if(addDrill){
        this.currentDrillId = undefined
        this.getDrillData(1, this.currentSectionId)
      }
    },
    addDrill() {
      console.log(this.currentSubDrillType)
      this.visible = true
    },
    openAddFragmentModal() {
      this.addFragmentVisible = true
    },
    async addFragment() {
      console.log('addFragment')
      console.log(this.currentFragmentId, this.currentSectionId)
      try{
        this.loading = true
        await fragmentApi.addSectionLink(this.currentSectionId, this.currentFragmentId)
        this.addFragmentVisible = false
        await this.getFragmentData(1, this.currentSectionId)
      }catch(e) {
        this.$message.error(e)
      }finally{
        this.loading = false
      }
    },
    changeCurrentSubDrillType(e) {
      this.currentSubDrillType = e[e.length - 1]
      console.log(e)
    },
    selectDrillType() {
      console.debug(this.currentSubDrillType)
      this.visible = false
      if(this.currentSubDrillType < 200){
        this.currentDrillId = undefined
        this.showChoiceQuestionTimes++
      }else if(this.currentSubDrillType < 300){
        this.currentDrillId = undefined
        this.showGapFillingTimes++
      }else if(this.currentSubDrillType < 400){
        this.currentDrillId = undefined
        this.showEssayQuestionTimes++
      }else if(this.currentSubDrillType < 500){
        this.currentDrillId = undefined
        this.showDialogueTimes++
      }else if(this.currentSubDrillType < 600){
        this.currentDrillId = undefined
        this.showReadbackTimes++
      }else if(this.currentSubDrillType < 700){
        this.currentDrillId = undefined
        this.showPassageChoiceTimes++
      }else if(this.currentSubDrillType < 800){
        this.currentDrillId = undefined
        this.showSequencingDrillTimes++
      }else if(this.currentSubDrillType < 900){
        this.currentDrillId = undefined
        this.showPassageSequencingDrillTimes++
      }
    },
    copySectionCode(section) {
      console.log(section)
      const input = document.createElement('input');
      document.body.appendChild(input);
      input.setAttribute('value', ` data-file-id="${section.id}" `);
      input.select();
      if (document.execCommand('copy')) {
          document.execCommand('copy');
          this.$message.success('复制成功')
      }
      document.body.removeChild(input);
    },
    openHtmlEditor(unit, lesson) {
      console.log(unit, lesson)
      let {id} = this.$route.params;
      this.$router.push({name: 'TextbookMaker', params: {textbookId: id, unitId: unit.id, lessonId: lesson.id}})
    },
    async deleteDrill(drill) {
      console.log(drill)
      try{
        this.loading = true
        if(drill.type == 100){
          await choiceQuestionDrillApi.removeDrill(drill.id)
        }else if(drill.type == 200) {
          await gapFillingDrillApi.removeDrill(drill.id)
        }else if(drill.type == 300) {
          await essayQuestionDrillApi.removeDrill(drill.id)
        }else if(drill.type == 400) {
          await dialogueDrillApi.removeDrill(drill.id)
        }else if(drill.type == 500) {
          await readbackDrillApi.removeDrill(drill.id)
        }else if(drill.type == 600) {
          await passageChoiceDrillApi.removeDrill(drill.id)
        }else if(drill.type == 700) {
          await sequencingDrillApi.removeDrill(drill.id)
        }else if(drill.type == 800) {
          await passageSequencingDrillApi.removeDrill(drill.id)
        }
        await this.getDrillData(this.currentDrillPageNum, this.currentSectionId)
      }catch(e) {
        console.log(e)
        this.$message.error('删除出错')
      }finally{
        this.loading = false
      }
    },
    versionTime(versionNum){
      let date = new Date( Number(versionNum))
      return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
    },
    onPuseVersion(){
      console.log(this.textbookDetail)
      console.log(this.textbookDetail.id)
      const url = 'https://fm-textnization-cvqylwwfqo.cn-shenzhen.fcapp.run/';

      const data = {
          textbook_id: this.textbookDetail.id,
          textbook_id:"1"
      };

      fetch(url, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
      })
      .then(response => response.json())
      .then(data => {
          console.log('Response:', data);
      })
      .catch(error => {
          console.error('Error:', error);
      });
    },
    async onClickBookFormat(){
      this.$message.info('数据上传中')
      this.loading = true
      console.log(this.textbookDetail)
      console.log(this.textbookDetail.id)
      const url = 'https://fm-textook-pack-socerfblta.cn-shenzhen.fcapp.run/';

      const data = {
          textbook_id: this.textbookDetail.id,
          "action":"source_format"
      };

      try{
        let response = await fetch(url, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
        let respData = await response.json()
        console.log('Response:', respData);
        this.loading = false
      }catch(e) {
        console.error('Error:', error);
        this.$message.error(error)
        throw e
      }finally{
        this.loading = false
      }
    },
    async submitUnitToReview(unitId){
      try{
        await this.onClickBookFormat()
      }catch(e) {
        return
      }
      this.$message.info('单元上传中')
      console.log(this.textbookDetail)
      console.log(this.textbookDetail.id)
      this.loading = true
      var that = this
      const url = 'https://fm-textook-pack-socerfblta.cn-shenzhen.fcapp.run/';

      const data = {
          textbook_id: this.textbookDetail.id,
          "action":"units_submit",
          "unitIds":[unitId]
      };

      let response = await fetch(url, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
      })

      let respData = await response.json()
      await this.auditAction(data)
    },
    async auditAction(data){
      var unitId = data.unitIds[0];
      var dataVo = {
        unitId:unitId
      }
      this.loading = true
      console.log(dataVo)
      let createVo = await this.$store.dispatch('textbook/auditAction', dataVo)
      window.location.reload()
      this.loading = false
    },
    async copyVideoJSON(unitIndex, lessonIndex, section) {
      this.loading = true
      console.log(unitIndex, lessonIndex, section)
      // let resp = await fetch(`/api/drill/section_drill/?sectionId=${section.id}`, {
      //   method: 'GET',
      //   headers: {
      //     'Content-Type': 'application/json'
      //   },
      //   credentials: 'include'
      // });
      // let jsonStr = await resp.text();
      
      // console.log(JSONbigString.parse(jsonStr))
      let copyObject = {
        textbookId: this.textbookDetail.id,
        unitId: this.toc[unitIndex].id,
        lessonId: section.lessonId,
        sectionId: section.id,
        url: section.filePath
      }
      copy(JSONbigString.stringify(copyObject), {
        format: 'text/plain'
      })
      this.loading = false
      this.$message.success('复制成功')
    }
  }
}
</script>

<style lang="less" scoped>

</style>